import React, { Component } from 'react';
import { connect } from 'react-redux';
import VendorRegistrationAU from '../admin_module/vendor/vendorRegistration/vendorRegistration_au';
import VendorWorkOrderAU from '../admin_module/vendor/vendorWorkOrder/vendorWorkOrder_au';
import Loader from '../../utils/Loader';
import { ToastContainer } from 'react-toastify';
import ExhibitorHeader from '../../common_components/exhibitor_module_header';
import HeaderWithLogo from '../../common_components/header_with_logo';
import VendorDrawer from '../../common_components/vendor_module_drawer';
import AdminDrawer from "../../common_components/admin_module_drawer";
import { withRouter } from '../../utils/withRouter';
import HallManager from './hallManager_module';

class VendorAndScopofwork extends Component {
    constructor(props) {
        super(props)
        this.state = {
            RoleID: sessionStorage.getItem('RoleIDSS')
        }
    }

    render() {
        const {
            isLoading, RoleID
        } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {RoleID == 16 &&
                    <>
                        <HeaderWithLogo />
                        {/* <HallManager /> */}
                    </>
                }
                <VendorRegistrationAU />
                <VendorWorkOrderAU />
            </>
        );
    }
}

export default withRouter(connect(null, {

})(VendorAndScopofwork));